// Default height of a slider's progress bar
export const SLIDER_PROGRESS_BAR_HEIGHT = {
  xs: '6px',
  xl: '8px'
};
export const SLIDER_RAIL_TOUCH_SIZE = 80;
export const SLIDER_RAIL_CLICK_SIZE = 64;
export const SLIDER_RAIL_HORIZONTAL_SPACING = 16;

// Tick color for slider
export const SLIDER_TICK_COLOR = 'rgba(0, 0, 0, 0.15)';
export const SLIDER_TICK_LABEL_TOP_POSITION = 16;

// Default slider label left margin from slider itself
export const SLIDER_LABEL_MARGIN = {
  xs: '18px',
  md: '20px',
  xl: '22px'
};